var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.32 21.7405C18.12 21.7205 17.88 21.7205 17.66 21.7405C15.3644 21.6625 13.1893 20.6941 11.5953 19.0404C10.0012 17.3866 9.11348 15.1774 9.12 12.8805C9.12 7.98047 13.08 4.00047 18 4.00047C20.3525 3.95803 22.6254 4.85185 24.3189 6.48529C26.0124 8.11874 26.9876 10.358 27.03 12.7105C27.0724 15.0629 26.1786 17.3359 24.5452 19.0294C22.9117 20.7228 20.6725 21.698 18.32 21.7405ZM8.32 29.1205C3.48 32.3605 3.48 37.6405 8.32 40.8605C13.82 44.5405 22.84 44.5405 28.34 40.8605C33.18 37.6205 33.18 32.3405 28.34 29.1205C22.86 25.4605 13.84 25.4605 8.32 29.1205Z",
    stroke: "#3366FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.82 8C36.7 8 39.82 11.14 39.82 15C39.82 18.78 36.82 21.86 33.08 22C32.9072 21.98 32.7328 21.98 32.56 22M36.68 40C38.12 39.7 39.48 39.12 40.6 38.26C43.72 35.92 43.72 32.06 40.6 29.72C39.5 28.88 38.16 28.32 36.74 28",
    stroke: "#19337F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.5b4281cde4aba7a0c118dd529c493b6a.svg";
export { ForwardRef as ReactComponent };